import type { WindowKey } from "owa-bizchat-types";
import type { MailboxInfo } from "owa-client-types";
import { setTasksHubActiveMutator } from "owa-copilot-chat-drawer-store";
import { logTasksHubViewed, type TasksHubViewSource } from "./logTasksHubViewed";
import { markTasksHubShown } from "./tasksHubVisitClock";

export function showTasksHub(windowKey: WindowKey, mailboxInfo: MailboxInfo, source: TasksHubViewSource): void {
    setTasksHubActiveMutator(windowKey, true);
    markTasksHubShown(windowKey);
    logTasksHubViewed(mailboxInfo, source);
}
